import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import oneAppModuleWrapper from '@americanexpress/one-app-module-wrapper';
import { connectAsync } from 'iguazu';
import { queryModuleWithData } from 'iguazu-holocron';
import useLangpackLoader from '@americanexpress/one-identity-components/lib/hooks/useLangpackLoader';
import { getShowIdentityUiManagementCenter } from '../selectors';

const IdentityManagementCenterWrapper = ({
  IdentityUiManagementCenter,
  OneIdentityManagementCenter,
  showIdentityUiManagementCenter,
  loadStatus,
  location,
  route,
}) => {
  useLangpackLoader({ moduleName: 'one-identity-root' });

  if (loadStatus.all !== 'complete') {
    return null;
  }

  // Check for market flag
  return showIdentityUiManagementCenter
    ? <IdentityUiManagementCenter location={location} />
    : <OneIdentityManagementCenter location={location} route={route} />;
};

IdentityManagementCenterWrapper.propTypes = {
  IdentityUiManagementCenter: PropTypes.func.isRequired,
  OneIdentityManagementCenter: PropTypes.node.isRequired,
  showIdentityUiManagementCenter: PropTypes.bool.isRequired,
  loadStatus: PropTypes.shape({
    all: PropTypes.string,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
  route: PropTypes.shape({
    path: PropTypes.string,
  }).isRequired,
};

export const ComponentToTest = IdentityManagementCenterWrapper;

const loadDataAsProps = ({ store: { dispatch, getState } }) => ({
  IdentityUiManagementCenter: () => dispatch(queryModuleWithData('identity-ui-management-center')),
  OneIdentityManagementCenter: () => dispatch(queryModuleWithData('one-identity-management-center')),
  showIdentityUiManagementCenter: () => ({ status: 'complete', data: getShowIdentityUiManagementCenter(getState()) }),
});

const hocChain = compose(
  oneAppModuleWrapper(IdentityManagementCenterWrapper),
  connectAsync({ loadDataAsProps })
);

export default hocChain(IdentityManagementCenterWrapper);
